import moment from "moment";
import locale_nl from "moment/locale/nl";

moment.locale("nl", locale_nl);

export default moment;
